"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _KeyboardArrowRight2 = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));

var _KeyboardArrowLeft2 = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var navigate = {
  PREVIOUS: "PREV",
  NEXT: "NEXT",
  TODAY: "TODAY",
  DATE: "DATE"
};

var CustomToolbar = function CustomToolbar(props) {
  var onNavigate = props.onNavigate,
      messages = props.localizer.messages,
      label = props.label,
      onView = props.onView,
      views = props.views,
      view = props.view;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      marginTop: "0.25rem",
      marginBottom: "0.875rem",
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      width: "33.333333%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disableRipple: true,
    style: {
      backgroundColor: "#F2F2F2"
    },
    onClick: function onClick() {
      return onNavigate(navigate.TODAY);
    }
  }, messages.today), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      marginLeft: "0.5rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft2["default"], {
    style: {
      cursor: "pointer"
    },
    onClick: function onClick() {
      return onNavigate(navigate.PREVIOUS);
    }
  }), /*#__PURE__*/_react["default"].createElement(_KeyboardArrowRight2["default"], {
    style: {
      marginLeft: "0.5rem",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return onNavigate(navigate.NEXT);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: "1.125rem",
      fontWeight: 600,
      marginLeft: "0.5rem",
      whiteSpace: "nowrap"
    }
  }, label))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "33.333333%"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "33.333333%",
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      width: "100%",
      padding: "0.25rem",
      backgroundColor: "#F2F2F2",
      borderRadius: "0.25rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      width: "33.333333%",
      textAlign: "center",
      textTransform: "capitalize",
      borderRadius: "0.25rem",
      backgroundColor: view === views[0] ? "#757575" : "unset",
      color: view === views[0] ? "white" : "#757575",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return onView(views[0]);
    }
  }, views[0]), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      width: "33.333333%",
      textAlign: "center",
      textTransform: "capitalize",
      borderRadius: "0.25rem",
      backgroundColor: view === views[1] ? "#757575" : "unset",
      color: view === views[1] ? "white" : "#757575",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return onView(views[1]);
    }
  }, views[1]), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      width: "33.333333%",
      textAlign: "center",
      textTransform: "capitalize",
      borderRadius: "0.25rem",
      backgroundColor: view === views[2] ? "#757575" : "unset",
      color: view === views[2] ? "white" : "#757575",
      cursor: "pointer"
    },
    onClick: function onClick() {
      return onView(views[2]);
    }
  }, views[2]))));
};

var _default = CustomToolbar;
exports["default"] = _default;